"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeModifierImpl = exports.DateTimeModifier = void 0;
const UTCTimeZone_1 = require("./UTCTimeZone");
const exception_1 = require("@almservices-cl/exception");
const check_1 = __importDefault(require("./check"));
const moment_1 = __importDefault(require("moment"));
const Range_1 = require("./Range");
class DateTimeModifier {
}
exports.DateTimeModifier = DateTimeModifier;
class DateTimeModifierImpl {
    constructor() {
        this.setFormats = (dateTimeFormat, dateFormat) => {
            this.dateTimeFormat = dateTimeFormat;
            this.dateFormat = dateFormat;
        };
        this.modifyDays = (date, days) => {
            const dt = (0, moment_1.default)(date, this.dateFormat);
            if (days >= 0) {
                return (0, check_1.default)(dt.add({ days }).format(this.dateFormat));
            }
            return (0, check_1.default)(dt.subtract({ days: days * -1 }).format(this.dateFormat));
        };
        this.modifyMonths = (date, months) => {
            const dt = (0, moment_1.default)(date, this.dateFormat);
            if (months >= 0) {
                return (0, check_1.default)(dt.add({ months }).format(this.dateFormat));
            }
            return (0, check_1.default)(dt.subtract({ months: months * -1 }).format(this.dateFormat));
        };
        this.yearDiff = (dateA, dateB) => {
            const a = (0, moment_1.default)(dateA).get("year");
            const b = (0, moment_1.default)(dateB).get("year");
            return a - b;
        };
        this.extractTimeZone = (dateTime) => {
            const timeZoneMatch = dateTime.match("(\\+|-)\\d{2}:\\d{2}");
            if (timeZoneMatch) {
                return UTCTimeZone_1.UTCTimeZone.fromString(timeZoneMatch[0]);
            }
            if (dateTime.substr(-1, 1) === "Z") {
                return UTCTimeZone_1.UTCTimeZone.z();
            }
            throw new exception_1.BadMethodCallException(`${dateTime} does not consists of time zone info`);
        };
        this.assertDateTime = (dateTime) => {
            if (dateTime.length < 11) {
                throw new exception_1.BadMethodCallException(dateTime + " is not a dateTime!");
            }
        };
        this.modifyHours = (dateTime, hours, timeZone) => {
            this.assertDateTime(dateTime);
            try {
                if (!timeZone) {
                    timeZone = this.extractTimeZone(dateTime);
                }
            }
            catch (e) {
                // ignore
            }
            let dt = (0, moment_1.default)(dateTime, this.dateTimeFormat);
            if (timeZone) {
                dt = dt.utcOffset(timeZone.toString());
            }
            return (0, check_1.default)(dt.add({ hours }).format(this.dateTimeFormat));
        };
        this.modifyMinutes = (dateTime, minutes) => {
            this.assertDateTime(dateTime);
            const timeZone = this.extractTimeZone(dateTime);
            const dt = (0, moment_1.default)(dateTime, this.dateFormat + "THH:mm:ssZ").utcOffset(timeZone.toString());
            if (minutes >= 0) {
                return (0, check_1.default)(dt.add({ minutes }).format(`${this.dateFormat}THH:mm:ssZ`));
            }
            return (0, check_1.default)(dt
                .subtract({ minutes: minutes * -1 })
                .format(`${this.dateFormat}THH:mm:ssZ`));
        };
        this.formattedAsMomentObject = (dateFormatted) => {
            let obj = (0, moment_1.default)(dateFormatted.date, dateFormatted.format);
            if (dateFormatted.timeZone) {
                obj = obj.utcOffset(dateFormatted.timeZone.toString());
            }
            return obj;
        };
        this.diffHoursFormatted = (dateA, dateB) => {
            return parseInt(moment_1.default
                .duration(this.formattedAsMomentObject(dateB).diff(this.formattedAsMomentObject(dateA)))
                .asHours()
                .toString());
        };
        this.diffHours = (dateA, dateB) => {
            const formatA = dateA.length === 10 ? this.dateFormat : this.dateTimeFormat;
            const formatB = dateB.length === 10 ? this.dateFormat : this.dateTimeFormat;
            return this.diffHoursFormatted({
                date: dateA,
                format: formatA,
                timeZone: UTCTimeZone_1.UTCTimeZone.z(),
            }, {
                date: dateB,
                format: formatB,
                timeZone: UTCTimeZone_1.UTCTimeZone.z(),
            });
        };
        this.daysDiff = (dateA, dateB) => {
            const b = (0, moment_1.default)(dateB + "T00:00:00+00:00", this.dateFormat).utcOffset("+00:00");
            const a = (0, moment_1.default)(dateA + "T00:00:00+00:00", this.dateFormat).utcOffset("+00:00");
            const diff = b.diff(a);
            return Math.round(moment_1.default.duration(diff).asDays());
        };
        this.monthsDiff = (dateA, dateB) => {
            const b = (0, moment_1.default)(dateB + "T00:00:00+00:00", this.dateFormat).utcOffset("+00:00");
            const a = (0, moment_1.default)(dateA + "T00:00:00+00:00", this.dateFormat).utcOffset("+00:00");
            const diff = b.diff(a);
            return Math.round(moment_1.default.duration(diff).asMonths());
        };
        this.calcDaysToEvent = (eventDate, currentDateTime) => {
            const nowMoment = (0, moment_1.default)(currentDateTime);
            let futureEventDate = (0, moment_1.default)(eventDate).set("year", nowMoment.get("year"));
            let diff = futureEventDate.diff(nowMoment, "day");
            if (diff < 0) {
                futureEventDate = (0, moment_1.default)(eventDate, this.dateFormat).set("year", nowMoment.get("year") + 1);
                diff = futureEventDate.diff(nowMoment, "day");
            }
            return diff;
        };
        this.dateIsSameOrAfter = (a, b) => {
            return (0, moment_1.default)(a).isSameOrAfter(b);
        };
        this.dateInDateRange = (start, end, date) => {
            const d = (0, moment_1.default)(date);
            return d.isSameOrAfter(start) && d.isSameOrBefore(end);
        };
        this.getWeekBoundaryFromDate = (date) => {
            const weekStart = (0, moment_1.default)(date).startOf("isoWeek").format("YYYY-MM-DD");
            const weekEnd = (0, moment_1.default)(date).endOf("isoWeek").format("YYYY-MM-DD");
            return new Range_1.Range(weekStart, weekEnd);
        };
        this.isCurrentMonth = (year, month) => {
            const date = (0, moment_1.default)();
            date.set({
                year,
                month,
            });
            return date.isSameOrAfter((0, moment_1.default)(), "month");
        };
    }
}
exports.DateTimeModifierImpl = DateTimeModifierImpl;
//# sourceMappingURL=DateTimeModifier.js.map